(function () {
  var notif = document.getElementById('cart-notif');
  if (!notif) return;

  var closeBtn = notif.querySelector('.cart-notif__close');
  var progressFill = notif.querySelector('.cart-notif__progress::after'); // not directly selectable, see note below
  var progressEl = notif.querySelector('.cart-notif__progress');
  var hideTimer;
  var DURATION = 2800;

  function showNotif() {
    clearTimeout(hideTimer);

    // Retrigger the check-draw and progress-bar animations even if the
    // notif is already visible (rapid repeat add-to-cart clicks)
    notif.classList.remove('is-visible');
    void notif.offsetWidth; // force reflow so the removed class registers

    notif.classList.add('is-visible');
    if (progressEl) {
      progressEl.style.setProperty('--dur', DURATION + 'ms');
    }

    hideTimer = setTimeout(function () {
      notif.classList.remove('is-visible');
    }, DURATION);
  }

  function hideNotif() {
    clearTimeout(hideTimer);
    notif.classList.remove('is-visible');
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', hideNotif);
  }

  var originalFetch = window.fetch;
  window.fetch = function (url, options) {
    var isAddToCart = typeof url === 'string' && url.indexOf('/cart/add') !== -1;
    return originalFetch.apply(this, arguments).then(function (response) {
      if (isAddToCart && response.ok) showNotif();
      return response;
    });
  };

  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._url = url;
    return originalOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this._url && this._url.indexOf('/cart/add') !== -1) {
      this.addEventListener('load', function () {
        if (this.status === 200) showNotif();
      });
    }
    return originalSend.apply(this, arguments);
  };
})();